module.exports = __webpack_public_path__ + "img/13.de16bdac.jpg";